import { useEffect, useState } from 'react';
import { usePaymentContext } from '../../../../../parking/ui/booking-steps/payment/PaymentContext';
import { createFlexMicroform } from '../../../../../shared/api/cybersource/createFlexMicroform';
import { logError } from '../../../../../shared/error/logError';
import type { CaptureContextStore } from '../../../../domain/stores/CaptureContextStore';

export const useFlexMicroform = (captureContextStore: CaptureContextStore) => {
	const [error, setError] = useState<Error>();
	const { setMicroformInstance, microformInstance } = usePaymentContext();

	useEffect(() => {
		if (
			!captureContextStore.value &&
			!captureContextStore.isLoading &&
			!captureContextStore.clientLibrary &&
			!captureContextStore.clientLibraryIntegrity
		) {
			captureContextStore.load();
		}
	}, [captureContextStore]);

	useEffect(() => {
		if (!captureContextStore.value) return undefined;
		if (!captureContextStore.clientLibrary) return undefined;
		if (!captureContextStore.clientLibraryIntegrity) return undefined;

		const cleanup = createFlexMicroform({
			jwt: captureContextStore.value,
			clientLibrary: captureContextStore.clientLibrary,
			clientLibraryIntegrity: captureContextStore.clientLibraryIntegrity,
			onError: (e) => {
				logError(e);
				setError(e);
			},
			onLoad: (data) => {
				setMicroformInstance(data);
			},
		});

		return () => {
			cleanup();
			setMicroformInstance(undefined);
		};
	}, [
		captureContextStore.value,
		captureContextStore.clientLibrary,
		captureContextStore.clientLibraryIntegrity,
		setMicroformInstance,
	]);

	return {
		error: error || captureContextStore.error,
		microform: microformInstance,
	};
};
